import { render, staticRenderFns } from "./InboxNotif.vue?vue&type=template&id=0b332842&"
import script from "./InboxNotif.vue?vue&type=script&lang=js&"
export * from "./InboxNotif.vue?vue&type=script&lang=js&"
import style0 from "./InboxNotif.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports